import { modules } from "byzantine";

import MarketingImageTargetWeb from "../../marketing";
import {
  MARKETING_BANNER_IMAGE_ADDRESS,
  MARKETING_CARD_IMAGE_ADDRESS,
  LARGE_MARKETING_BANNER_IMAGE_ADDRESS,
  LARGE_MARKETING_IMAGE_ADDRESS
} from "../constants";
import useIsMarketingBannersEnabled from "./hooks";

export type ImagePlacementAddress =
  | typeof MARKETING_CARD_IMAGE_ADDRESS
  | typeof MARKETING_BANNER_IMAGE_ADDRESS
  | typeof LARGE_MARKETING_IMAGE_ADDRESS
  | typeof LARGE_MARKETING_BANNER_IMAGE_ADDRESS;

const { useDashboardLayoutRedesignEnabled } = modules.dashboard;

const redesignPlacementAddressByAddress: Partial<
  Record<ImagePlacementAddress, ImagePlacementAddress>
> = {
  [MARKETING_CARD_IMAGE_ADDRESS]: LARGE_MARKETING_IMAGE_ADDRESS,
  [MARKETING_BANNER_IMAGE_ADDRESS]: LARGE_MARKETING_BANNER_IMAGE_ADDRESS
};

interface MarketingImageBannerProps {
  address: ImagePlacementAddress;
}

const getPlacementAddress = (
  address: ImagePlacementAddress,
  isDashboardLayoutRedesignEnabled: boolean
) =>
  isDashboardLayoutRedesignEnabled
    ? redesignPlacementAddressByAddress[address] ?? address
    : address;

const MarketingImage = ({ address }: MarketingImageBannerProps) => {
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();
  const placementAddress = getPlacementAddress(
    address,
    isDashboardLayoutRedesignEnabled
  );

  const isMarketingBannersEnabled = useIsMarketingBannersEnabled();

  return isMarketingBannersEnabled ? (
    <MarketingImageTargetWeb address={placementAddress} />
  ) : null;
};

export default MarketingImage;
